import { Head, Link, useForm } from '@inertiajs/react'
import AuthPanel from '../../components/AuthPanel'
import TextField from '../../components/TextField'
import { buttonClass, linkClass } from '../../components/ui'

export default function PasswordsNew() {
  const form = useForm({ email_address: '' })

  return (
    <>
      <Head title="Reset password" />
      <AuthPanel
        title="Reset your password"
        description="Enter your account email to request a password reset link."
        footer={<Link href="/session/new" className={linkClass}>Back to sign in</Link>}
      >
        <form
          className="space-y-5"
          aria-busy={form.processing}
          onSubmit={(e) => {
            e.preventDefault()
            form.post('/passwords')
          }}
        >
          <TextField label="Email" name="email_address" type="email" autoComplete="username" required
            value={form.data.email_address} onChange={(v) => form.setData('email_address', v)} />
          <button type="submit" className={`${buttonClass} w-full`} disabled={form.processing}>
            {form.processing ? 'Sending link…' : 'Email reset link'}
          </button>
        </form>
      </AuthPanel>
    </>
  )
}
